export default "__VITE_ASSET__pyUZNC7G__"